var _path, _path2, _path3, _g, _path4, _path5, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNasdaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6500_10824)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6500_10824)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6500_10824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6500_10824)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#0996C7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6500_10824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 12,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8086 9.53369H28.2649V22.3075H17.8086V9.53369Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6500_10824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2345 9.53369L18.8126 21.6824C18.7579 21.832 18.6622 21.9631 18.5365 22.0609C18.4107 22.1586 18.26 22.219 18.1016 22.235V22.2408H22.7759C23.1419 22.2408 23.4552 22.0081 23.5718 21.6828L27.9952 9.53369H23.2345Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7194 22.0565C17.9905 22.0565 18.2279 21.9218 18.3731 21.7177C18.3882 21.6964 18.4412 21.622 18.4788 21.5209L20.1007 17.0627L19.1519 14.459C19.0966 14.3272 19.0071 14.2125 18.8926 14.1269C18.7781 14.0413 18.6428 13.9879 18.5007 13.9721C18.3586 13.9564 18.2149 13.979 18.0845 14.0375C17.954 14.096 17.8416 14.1883 17.7589 14.3049C17.7434 14.3262 17.6803 14.4211 17.6531 14.5016L16.0312 18.9583L16.9843 21.5724C17.0462 21.7161 17.1487 21.8385 17.2793 21.9246C17.41 22.0106 17.563 22.0565 17.7194 22.0565Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6500_10824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 12,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73828 13.4004H18.1946V26.489H7.73828V13.4004Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6500_10824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0662 13.7817H13.3404C12.9744 13.7817 12.6611 14.0133 12.543 14.3402L8.12109 26.4889H12.8818L17.3041 14.3406C17.3614 14.1825 17.4646 14.0451 17.6003 13.9459C17.736 13.8466 17.8982 13.79 18.0662 13.7833V13.7817Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6500_10824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6500_10824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNasdaq);
export default __webpack_public_path__ + "static/media/nasdaq.e3d753f751ea8ba080eed315d3611459.svg";
export { ForwardRef as ReactComponent };